import {
  createTRPCClient,
  httpBatchLink,
  httpLink,
  isNonJsonSerializable,
  loggerLink,
  splitLink,
} from '@trpc/client';
import { clientHttp } from '@/common/http';
import { EVENT_HOST } from '@/common/url';
import type { AppRouter } from './routers/app';
import { transformer } from './transformer';

export function makeTrpcClient() {
  const base = typeof window === 'undefined' ? '' : EVENT_HOST;

  return createTRPCClient<AppRouter>({
    links: [
      loggerLink(),
      splitLink({
        condition: (op) => isNonJsonSerializable(op.input),
        true: httpLink({
          url: `${base}/api/trpc`,
          fetch: clientHttp,
          transformer,
        }),
        false: httpBatchLink({
          url: `${base}/api/trpc`,
          fetch: clientHttp,
          transformer,
        }),
      }),
    ],
  });
}
